"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_2 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var product_1 = require("../../ducks/product");
var ThreeDRotationIcon_1 = __importDefault(require("../../../common/Icons/ThreeDRotationIcon"));
var Modal_1 = __importDefault(require("../../../common/Modal"));
var ThreeDViewer_1 = __importDefault(require("../../../common/ThreeDViewer"));
var Loader_1 = __importDefault(require("../../../common/Loader"));
var three_d_button_module_scss_1 = __importDefault(require("./three-d-button.module.scss"));
function ThreeDButton(props) {
    var className = props.className;
    var product = (0, react_redux_1.useSelector)(product_1.productSelector);
    var show3d = product.show3d, loading = product.loading;
    var _a = (0, react_1.useState)(false), isOpen = _a[0], setIsOpen = _a[1];
    return show3d ? (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, three_d_button_module_scss_1.default.root) },
        react_1.default.createElement("div", { className: three_d_button_module_scss_1.default.button },
            react_1.default.createElement("a", { href: "#", onClick: function (e) {
                    e.preventDefault();
                    setIsOpen(true);
                }, className: three_d_button_module_scss_1.default.title },
                react_1.default.createElement("span", { className: three_d_button_module_scss_1.default.icon },
                    react_1.default.createElement(ThreeDRotationIcon_1.default, null)),
                react_1.default.createElement("span", { className: three_d_button_module_scss_1.default.text }, "\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440"))),
        isOpen && (react_1.default.createElement(Modal_1.default, { isOpen: isOpen, onRequestClose: function () { return setIsOpen(false); } },
            react_1.default.createElement("div", { className: three_d_button_module_scss_1.default.threeDViewer },
                loading && react_1.default.createElement(Loader_1.default, null),
                react_1.default.createElement(ThreeDViewer_1.default, { enable: props.enableThreeDViewer, disable: props.disableThreeDViewer })))))) : (react_1.default.createElement("div", null));
}
exports.default = (0, react_redux_2.connect)(null, {
    enableThreeDViewer: product_1.enableThreeDViewer,
    disableThreeDViewer: product_1.disableThreeDViewer,
})(ThreeDButton);
